<h2 class="mat-h2">Users</h2>

<div class="toolbar">
  <mat-form-field appearance="outline" class="search">
    <mat-label>Search</mat-label>
    <input matInput [(ngModel)]="search" (ngModelChange)="apply()"
           placeholder="email, name or production">
  </mat-form-field>

  <mat-form-field appearance="outline" class="narrow">
    <mat-label>Role</mat-label>
    <mat-select [(ngModel)]="roleFilter" (ngModelChange)="apply()">
      <mat-option value="">All</mat-option>
      <mat-option *ngFor="let role of roles" [value]="role">{{ role }}</mat-option>
    </mat-select>
  </mat-form-field>

  <span class="count">{{ visible.length }} of {{ rows.length }}</span>
</div>

<table class="users">
  <thead>
    <tr>
      <th class="sortable" (click)="sortBy('email')">email <span class="caret">{{ caret('email') }}</span></th>
      <th class="sortable" (click)="sortBy('displayName')">displayName <span class="caret">{{ caret('displayName') }}</span></th>
      <!-- The role names are the raw ones on purpose — this table is the
           answer to "what exactly does this account hold" — but one of them
           needs saying out loud, because its whole point is what it does not
           grant. -->
      <th *ngFor="let role of roles" class="sortable role-cell" (click)="sortBy(role)"
          [title]="roleHint(role)">
        {{ role }} <span class="caret">{{ caret(role) }}</span>
      </th>
      <th class="sortable" (click)="sortBy('production')">production <span class="caret">{{ caret('production') }}</span></th>
      <th></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let row of visible">
      <td>{{ row.user.email }}</td>
      <td>{{ row.user.displayName }}</td>
      <td *ngFor="let role of roles" class="role-cell">
        <mat-checkbox [checked]="has(row, role)"
                      (change)="toggle(row, role, $event.checked)"></mat-checkbox>
      </td>
      <td>
        <mat-form-field appearance="outline" class="narrow" *ngIf="has(row, 'producer')">
          <mat-select [(ngModel)]="row.channelId">
            <mat-option [value]="null">—</mat-option>
            <mat-option *ngFor="let producer of producers" [value]="producer.channelId">
              {{ producer.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <!-- The channel number is what the assignment really is — a name gets
             renamed, 4473 does not — so it is on the screenshot too. -->
        <span class="channel" *ngIf="row.channelId">#{{ row.channelId }}</span>
      </td>
      <td>
        <button mat-stroked-button
                [disabled]="!changed(row) || incomplete(row) || busy === row.user.uid"
                (click)="save(row)">Save
        </button>
        <span class="hint" *ngIf="incomplete(row)">pick a production</span>
      </td>
    </tr>
  </tbody>
</table>

<p class="hint-muted" *ngIf="!visible.length && rows.length">No account matches the filter.</p>
